export default {
  resource:{
    zh: {
      title:"账户流水",
      //empId, empName, amount, expand, balance, xdate, rcType, remark
      empId:	"工号",
      empName:	"姓名",
      amount: "变动前余额",
      expand: "变动金额",
      balance:	"变动后余额",
      xdate:	"日期",
      xdate1:	"开始日期",
      xdate2:	"结束日期",
      xtime:	"时间",
      rcType:"经办/来源",
      rType:"充值/消费",
      rType1:"充值",
      rType2:"消费",
      remark:"项目"
    }
  },
  params: {
    rType: {
      key: "rType",
      data:"0",
      method: "Equal",
      type: "select",
      options: [{
        value: "0",
        text: "All"
      }, {
        value: "1",
        rsText: "rType1"
      }, {
        value: "2",
        rsText: "rType2"
      }]
    },
    xdate1:{
      key: "xdate",
      tkey: "xdate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    xdate2:{
      key: "xdate",
      tkey: "xdate2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      more: true,
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      more: true,
      type: "text"
    }
  },
  isShowMore: true,
  listDefine: [
    "empId", "empName","amount","expand","balance",
    {key:"xdate", tkey:"xtime", formatter:"fdateTime"},"rcType","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"xdate",
  defaultSortOrder:"desc",
  sortName: "xdate",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "runningAccount/"

}
